import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useViewer } from "core/components/ViewerProvider";
import { useArena } from "arena/components/ArenaProvider";
import ChooseProduct from "./ChooseProduct";
import ChooseProvider from "./ChooseProvider";
import CreatePayment from "./CreatePayment";
import Payment from "./Payment";
import Product from "./Product";
import SignIn from "./SignIn";
import Loading from "./Loading";
import { useLocation, useNavigate } from "react-router-dom";

const screens = {
  SignIn,
  ChooseProduct,
  ChooseProvider,
  CreatePayment,
  Product,
  Payment,
  Loading,
};

const DefaultComponent = () => null;

export default function ProductDialog({
  product,
  content,
  state,
  dispatch,
  refetch,
  setPromocodeIds,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const viewer = useViewer();
  const arena = useArena();
  const location = useLocation();
  const navigate = useNavigate();

  const Component =
    screens[viewer === null ? "SignIn" : state.screen] || DefaultComponent;

  const onClose = () => {
    dispatch({ type: "close_dialog" });

    if (state.screen === "Payment") {
      navigate(location.pathname);
      refetch();
    }
  };

  return (
    <Dialog
      scroll="body"
      fullWidth
      fullScreen={fullScreen}
      maxWidth="sm"
      open={state.open}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      <Component
        content={content}
        state={state}
        onClose={onClose}
        dispatch={dispatch}
        arena={arena}
        refetch={refetch}
        product={product}
        setPromocodeIds={setPromocodeIds}
      />
    </Dialog>
  );
}

ProductDialog.propTypes = {
  content: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  refetch: PropTypes.func.isRequired,
  product: PropTypes.object,
  setPromocodeIds: PropTypes.func,
};
